import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

const SUBHAM_EVENTS = [
  'க்ருஹப்ரவேசம்','விவாஹம்','உபநயனம்','நாமகரணம்','அன்னப்ராசனம்','வாஹன ஆரம்பம்','வியாபார ஆரம்பம்',
  'புது வீடு கட்ட ஆரம்பம்','கல்வி ஆரம்பம்','நிச்சயதார்த்தம்','தீர்த்தயாத்திரை','பயணம்',
  'ஆயுத பூஜை','ஸஹஸ்ர நாமார்ச்சனை','வ்ரதம்'
];

const BestForEventsPage = () => {
  const [rules, setRules] = useState([]);
  const [sel, setSel] = useState(0);

  useEffect(() => {
    axios.get('/data/subham-rules.json').then(r => setRules(r.data)).catch(() => {});
  }, []);

  const eventRules = rules.filter(r => r.Event === SUBHAM_EVENTS[sel] || r.event === SUBHAM_EVENTS[sel]);

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>🎯 சுபமான நாட்கள்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Best Days for Important Events</div>
      </div>
      <select value={sel} onChange={e=>setSel(parseInt(e.target.value))}
        style={{width:'100%',padding:'8px',borderRadius:'8px',border:'2px solid '+T.greenDk,fontSize:'0.85rem',fontWeight:700,marginBottom:'10px'}}>
        {SUBHAM_EVENTS.map((e,i)=><option key={i} value={i}>{e}</option>)}
      </select>
      <div style={{background:T.cream,padding:'10px',borderRadius:'8px',border:'1px solid '+T.border,fontSize:'0.75rem',lineHeight:1.6,color:T.maroon}}>
        <div style={{fontWeight:800,fontSize:'0.9rem',color:T.greenDk,marginBottom:'8px'}}>✨ {SUBHAM_EVENTS[sel]} — விதிகள்</div>
        {eventRules.length > 0 ? eventRules.map((r,i)=>(
          <div key={i} style={{background:'#fff',padding:'8px',borderRadius:'6px',marginBottom:'4px',border:'1px solid #eee'}}>
            {Object.entries(r).filter(([k])=>k!=='Event'&&k!=='event'&&k!=='id').map(([k,v])=>(
              <div key={k}><b style={{color:T.greenDk}}>{k}:</b> {String(v)}</div>
            ))}
          </div>
        )) : (
          <div style={{textAlign:'center',color:'#888',padding:'20px'}}>
            நிகழ்வுக்கான விதிகள் — நக்ஷத்ரம், திதி, வாரம், யோகம் ஆகியவற்றின் அடிப்படையில் சுபமான நாட்களை தீர்மானிக்க முடியும்.
            <br/><br/>
            சுப நக்ஷத்ரங்கள்: ரோகிணி, மிருகசீர்ஷம், உத்திரம், அஸ்தம், சித்திரை, சுவாதி, அனுஷம், உத்திராடம், திருவோணம், அவிட்டம், ரேவதி
            <br/><br/>
            சுப திதிகள்: த்விதீயை, த்ருதீயை, பஞ்சமி, ஸப்தமி, தசமி, ஏகாதசி, த்ரயோதசி
          </div>
        )}
      </div>
    </div>
  );
};
export default BestForEventsPage;